/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  BigNumberish,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  StakingToken,
  StakingTokenInterface,
} from "../../contracts/StakingToken";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "initialSupply_",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "increasedSupply",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "cap",
        type: "uint256",
      },
    ],
    name: "ERC20ExceededCap",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "allowance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "needed",
        type: "uint256",
      },
    ],
    name: "ERC20InsufficientAllowance",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "needed",
        type: "uint256",
      },
    ],
    name: "ERC20InsufficientBalance",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "approver",
        type: "address",
      },
    ],
    name: "ERC20InvalidApprover",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "cap",
        type: "uint256",
      },
    ],
    name: "ERC20InvalidCap",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "ERC20InvalidReceiver",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "ERC20InvalidSender",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "ERC20InvalidSpender",
    type: "error",
  },
  {
    inputs: [],
    name: "EnforcedPause",
    type: "error",
  },
  {
    inputs: [],
    name: "ExpectedPause",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "cap",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type StakingTokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: StakingTokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class StakingToken__factory extends ContractFactory {
  constructor(...args: StakingTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    name_: string,
    symbol_: string,
    initialSupply_: BigNumberish,
    owner_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      name_,
      symbol_,
      initialSupply_,
      owner_,
      overrides || {}
    );
  }
  override deploy(
    name_: string,
    symbol_: string,
    initialSupply_: BigNumberish,
    owner_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(
      name_,
      symbol_,
      initialSupply_,
      owner_,
      overrides || {}
    ) as Promise<
      StakingToken & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): StakingToken__factory {
    return super.connect(runner) as StakingToken__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StakingTokenInterface {
    return new Interface(_abi) as StakingTokenInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): StakingToken {
    return new Contract(address, _abi, runner) as unknown as StakingToken;
  }
}
